import { Link } from 'react-router-dom';
import { LoginArea } from '@/components/auth/LoginArea';
import { Bitcoin, Vote } from 'lucide-react';

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/30 bg-background/80 backdrop-blur-xl backdrop-saturate-150">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
              <Bitcoin className="w-5 h-5 text-primary" />
            </div>
            <span className="font-display text-base sm:text-lg font-bold tracking-tight">
              <span className="text-bitcoin-gradient">MAXI</span>
              <span className="text-foreground"> MADNESS</span>
            </span>
          </Link>

          {/* Nav + Login */}
          <div className="flex items-center gap-1 sm:gap-3">
            <Link
              to="/round1"
              className="inline-flex items-center gap-1 text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors h-9 px-2 sm:px-3 rounded-md"
            >
              R1
            </Link>
            <Link
              to="/vote"
              className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-primary font-medium hover:text-primary/80 transition-colors h-9 px-2 sm:px-3 rounded-md"
            >
              <Vote className="w-4 h-4" />
              <span className="hidden sm:inline">Round 2</span>
              <span className="sm:hidden">R2</span>
            </Link>
            <LoginArea className="max-w-52" />
          </div>
        </div>
      </div>
    </header>
  );
}
